module.exports = __webpack_public_path__ + "img/message-plus.de3ba6c7.svg";